import { countries } from 'countries-list';
import { isString } from 'shared/utils';

export const currencyOptions = Object.entries(countries)
  .flatMap(([, { currency }]) => currency)
  .filter(isString)
  .filter((value) => value.trim() !== '')
  .filter((value, index, allValues) => allValues.indexOf(value) === index)
  .sort((a, b) => a.localeCompare(b));
